import React, {createContext, useContext, useEffect, useState} from 'react';
import defaultConfig from './defaultConfig';
import PropTypes from 'prop-types';

const SidebarContext = createContext();
const SidebarActionsContext = createContext();

export const useSidebarContext = () => useContext(SidebarContext);

export const useSidebarActionsContext = () => useContext(SidebarActionsContext);

const SidebarContextProvider = ({children}) => {
  const sidebar = localStorage.getItem('sidebar')
    ? JSON.parse(localStorage.getItem('sidebar'))
    : defaultConfig.sidebar;

  const [menuStyle, updateMenuStyle] = useState(sidebar?.menuStyle);
  const [sidebarColorSet, updateSidebarColorSet] = useState(sidebar?.colorSet);
  const [isSidebarBgImage, setSidebarBgImage] = useState(
    sidebar?.isSidebarBgImage,
  );
  const [sidebarBgImage, updateSidebarBgImage] = useState(
    sidebar?.sidebarBgImage,
  );
  const [sidebarMenuSelectedColor, updateSidebarMenuSelectedColor] = useState(
    sidebar?.sidebarMenuSelectedColor,
  );

  const updateSidebar = (key, value) => {
    let _sidebar = localStorage.getItem('sidebar')
      ? JSON.parse(localStorage.getItem('sidebar'))
      : defaultConfig.sidebar;

    _sidebar[key] = value;
    localStorage.setItem('sidebar', JSON.stringify(_sidebar));
  };

  useEffect(() => {
    updateSidebar('menuStyle', menuStyle);
  }, [menuStyle]);

  useEffect(() => {
    updateSidebar('colorSet', sidebarColorSet);
  }, [sidebarColorSet]);

  useEffect(() => {
    updateSidebar('isSidebarBgImage', isSidebarBgImage);
  }, [isSidebarBgImage]);

  useEffect(() => {
    updateSidebar('sidebarBgImage', sidebarBgImage);
  }, [sidebarBgImage]);

  useEffect(() => {
    updateSidebar('sidebarMenuSelectedColor', sidebarMenuSelectedColor);
  }, [sidebarMenuSelectedColor]);

  return (
    <SidebarContext.Provider
      value={{
        menuStyle,
        sidebarColorSet,
        isSidebarBgImage,
        sidebarBgImage,
        sidebarMenuSelectedColor,
      }}>
      <SidebarActionsContext.Provider
        value={{
          updateMenuStyle,
          updateSidebarColorSet,
          setSidebarBgImage,
          updateSidebarBgImage,
          updateSidebarMenuSelectedColor,
        }}>
        {children}
      </SidebarActionsContext.Provider>
    </SidebarContext.Provider>
  );
};

export default SidebarContextProvider;

SidebarContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
